module.exports = __webpack_public_path__ + "img/sunrise_thumbnail.cde5c858.webp";